<template>
  <v-sheet class="header-bar d-flex align-center justify-space-between">
    <img
      src="@/assets/login/abrIronLogo.png"
      alt="logo"
      width="100"
    />

    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          outlined
          height="37"
          color="primary"
        >
          <v-icon right>mdi-chevron-down</v-icon>
          <span class="ms-2">{{ model ? model.title : $t("select language") }}</span>
          <v-avatar size="22" class="mx-2">
            <v-img :src="model ? model.flagSrc : require('@/assets/iran.png')" alt="Lang" />
          </v-avatar>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="lang in languages"
          :key="lang.id"
          @click="changeLanguage(lang.lang)"
        >
          <v-list-item-avatar size="24">
            <v-img :src="lang.flagSrc" />
          </v-list-item-avatar>
          <v-list-item-title>{{ lang.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-sheet>
</template>

<script>
export default {
  name: "AppHeader",
  data: () => ({
    languages: [
      {
        id: 1,
        title: "فارسی",
        lang: "fa",
        rtl: true,
        flagSrc: require("@/assets/iran.png"),
      },
      {
        id: 2,
        title: "English",
        lang: "en",
        rtl: false,
        flagSrc: require("@/assets/england.png"),
      },
    ],
    model: null,
  }),
  mounted() {
    const langFromStore = this.$store.state.lang;
    const langStorage = JSON.parse(localStorage.getItem("lang"));

    const currentLang =
      this.languages.find(x => x.lang === (langStorage?.lang || langFromStore)) ||
      this.languages[0];

    this.model = currentLang;
    this.$root.$i18n.locale = currentLang.lang;
    this.$vuetify.rtl = currentLang.rtl;
  },
  methods: {
    changeLanguage(langCode) {
      const langObj = this.languages.find(l => l.lang === langCode);
      if (!langObj) return;

      this.model = langObj;

      const tokenStorage = JSON.parse(localStorage.getItem("token"));
      if (tokenStorage) {
        tokenStorage.init.lang.value = langObj.lang;
        localStorage.setItem("token", JSON.stringify(tokenStorage));
      } else {
        localStorage.setItem("lang", JSON.stringify(langObj));
      }

      this.$root.$i18n.locale = langObj.lang;
      this.$vuetify.rtl = langObj.rtl;
      this.$emit("input", langObj);
    },
  },
};
</script>

<style scoped>
.header-bar {
  opacity: 1;
  width: 100%;
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 12px 30px;
}
.border-primary {
  border: 1px solid #0065fc !important;
  border-radius: 8px;
}
@media (max-width: 580px) {
  .header-bar {
    padding: 8px 18px;
  }
}
</style>
